

const { createSlice } = require('@reduxjs/toolkit');

const initialState = {
    loading: false,
    data: [],
    completed: false,
};

const rowDataSlice = createSlice({
    name: 'googleTrendsRowData',
    initialState,
    reducers: {
        startLoading (state, action) {
            state.loading = true;
            state.data = [];
        },
        insertTrendRowData (state, action) {

            state.loading = false;
            state.completed = true;
            state.data = action.payload;
        },
        updateTrendRowData (state, action) {
            state.loading = false;
            state.completed = true;
        },
        clearTrendsSummary () {
            return initialState;
        },
    },
});

const googleTrendsRawDataReducer =  rowDataSlice.reducer;
const googleTrendsRawDataAction = rowDataSlice.actions;

export {googleTrendsRawDataAction};
export default googleTrendsRawDataReducer;

